function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#F2512D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33317 17.3334H14.6665V15.3334C14.6665 14.6 14.4054 13.9723 13.8832 13.45C13.3609 12.9278 12.7332 12.6667 11.9998 12.6667C11.2665 12.6667 10.6387 12.9278 10.1165 13.45C9.59428 13.9723 9.33317 14.6 9.33317 15.3334V17.3334ZM6.6665 18.6667V17.3334H7.99984V15.3334C7.99984 14.6556 8.15828 14.0194 8.47517 13.4247C8.79161 12.8305 9.23317 12.3556 9.79984 12C9.23317 11.6445 8.79161 11.1694 8.47517 10.5747C8.15828 9.98049 7.99984 9.34449 7.99984 8.66671V6.66671H6.6665V5.33337H17.3332V6.66671H15.9998V8.66671C15.9998 9.34449 15.8416 9.98049 15.5252 10.5747C15.2083 11.1694 14.7665 11.6445 14.1998 12C14.7665 12.3556 15.2083 12.8305 15.5252 13.4247C15.8416 14.0194 15.9998 14.6556 15.9998 15.3334V17.3334H17.3332V18.6667H6.6665Z",
  fill: "white"
});

function SvgRefunding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunding);
export default __webpack_public_path__ + "static/media/refunding.7426caa7.svg";
export { ForwardRef as ReactComponent };